import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DbEventsProvider } from 'src/app/providers/database/db.events';
import { DbAnalyticsProvider } from 'src/app/providers/database/db-analytics';
import { GlobalService } from 'src/app/providers/global/global.service';
import { FormatedEventLanguageService } from 'src/app/providers/formated-event-language/formated-event-language.service';
import { AppState } from 'src/app/shared/reducers';
import { Store } from '@ngrx/store';
import { getVisiosAnalytics } from 'src/app/shared/selectors/analytics.selectors';
import { take } from 'rxjs/operators';
declare let $: any;

@Component({
    selector: 'app-visio-analytics',
    templateUrl: './visio-analytics.component.html',
    styleUrls: ['./visio-analytics.component.scss']
})
export class VisioAnalyticsComponent implements OnInit {
    loader: boolean = true;

    event: any;
    eventId: string;
    userLanguage: string;

    totalPIM: number = 0;
    totalRoomsBetween2: number = 0;
    totalRoomsForEvent: number = 0;

    constructor(
        private route: ActivatedRoute,
        private dbEvent: DbEventsProvider,
        private dbAnalytics: DbAnalyticsProvider,
        private global: GlobalService,
        public formatedLanguage: FormatedEventLanguageService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.eventId = params.uid;
            this.getUserLanguage()
            this.getEvent();
        })
    }

    getUserLanguage() {
        this.global.getLanguage((language) => {
            this.userLanguage = this.formatedLanguage.convertLang(language);
        })
    }

    getEvent() {
        this.dbEvent.getEvent(this.eventId, (event) => {
            this.event = event;
            this.formatedLanguage.convertLangFormat(event.language);
            this.dbAnalytics.getVisiosAnalytics(this.eventId).pipe(take(1)).subscribe(() => {
                this.store.select(getVisiosAnalytics).subscribe((visiosAnalytics) => {
                    this.totalPIM = (visiosAnalytics && visiosAnalytics.totalPIM) ? visiosAnalytics.totalPIM : 0;
                    this.totalRoomsForEvent = (visiosAnalytics && visiosAnalytics.totalRoomsForEvent) ? visiosAnalytics.totalRoomsForEvent : 0;
                    this.totalRoomsBetween2 = (visiosAnalytics && visiosAnalytics.totalRoomsBetween2) ? visiosAnalytics.totalRoomsBetween2 : 0;

                    this.loader = false;
                })
            });
        });
    }

    /**
     * Export analytics of visio
     */
    exportAll() {
        this.loader = true;
        this.dbAnalytics.exportVisioAnalytics(this.eventId).subscribe(() => {
            this.loader = false;
        }, (error) => {
            this.loader = false;
        })
    }
}
